import Facebook from './channels/Facebook';
import Website from './channels/Website';
import Twitter from './channels/Twitter';
import Api from './channels/Api';
import Email from './channels/Email';
import Sms from './channels/Sms';
import Whatsapp from './channels/Whatsapp';
import Line from './channels/Line';
import Telegram from './channels/Telegram';
import IntertelUC from './channels/IntertelUC';
import StepTwo from './channels/evolutionApi/StepTwo.vue';
import StepThree from './channels/evolutionApi/StepThree.vue';
import StepFour from './channels/evolutionApi/StepFour.vue';

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  line: Line,
  telegram: Telegram,
  interteluc: IntertelUC,
  evolution_api: [StepTwo, StepThree, StepFour],
  // Aqui se agregan los nuevos canales ...
};

export default {
  create() {
    return {
      props: {
        channel_name: {
          type: String,
          required: true,
        },
        step: {
          type: Number,
          default: 1,
        },
      },
      name: 'new-channel-view',
      render(h) {
        const component =
          this.channel_name !== 'evolution_api'
            ? channelViewList[this.channel_name]
            : channelViewList[this.channel_name][this.step - 1];
        return h(component || null);
      },
    };
  },
};
